import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GatewayTimeoutImage } from 'assets/svg/404-page-not-found.svg'
import { ReactComponent as FixtabLogoWithTextImage } from 'assets/svg/fixtab-logo-with-text.svg'

import { currentVersion } from 'helpers/common'
import { redirectMainPage } from './management'

export const Error404Container = (): JSX.Element => {
  const { t } = useTranslation(['common', 'error'])

  return (
    <>
      <div className='con__error'>
        <div className='con__error__header'>
          <FixtabLogoWithTextImage />
        </div>

        <div className='con__error__body'>
          <GatewayTimeoutImage />

          <span className='con__error__title'>{t('error:notFound.title')}</span>

          <span className='con__error__content'>
            {t('error:notFound.content')}
          </span>

          <button className='con__error__btn' onClick={redirectMainPage}>
            <span>{t('common:mainPageFixtab.label')}</span>
          </button>
        </div>

        <div className='con__error__footer'>
          <span>
            {t('common:version.label')} {currentVersion}
          </span>
        </div>
      </div>
    </>
  )
}
